import React from "react";
import {
  Box,
  Button,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import ButtonBase from "@mui/material/ButtonBase";
// import Icon from "../../utils/Icon";
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import LanguageIcon from "@mui/icons-material/Language";
import StarIcon from "@mui/icons-material/Star";
import {Link} from "react-router-dom"





const SlickArrow = ({ currentSlide, slideCount, children, ...props }) => (
  <button {...props}>{children}</button>
);

export const CatererSlider = ({caterers}) => {

  
  const Img = styled("img")({
    margin: "auto",
    display: "block",
    maxWidth: "100%",
    maxHeight: "100%",
  });

  // function SampleNextArrow(props) {
  //   const { className, style, onClick } = props;
  //   return (
  //     <div
  //       className={className}
  //       style={{ ...style, display: "block", background: "red" }}
  //       onClick={onClick}
  //     />
  //   );
  // }

  // function SamplePrevArrow(props) {
  //   const { className, style, onClick } = props;
  //   return (
  //     <div
  //       className={className}
  //       style={{ ...style, display: "block", background: "green", }}
  //       onClick={onClick}
  //     />
  //   );
  // }

    const data = [
    {
      image: "./images/iMac Memoji2.svg",
      title: "Eagle Caterer Compani",
      desc: "Italian, American, 4 ++",
      rating: "4.7",
    },
    {
        image: "./images/iMac Memoji3.svg",
        title: "Eagle Caterer Compani",
        desc: "Italian, American, 4 ++",
        rating: "4.7",
      },
      {
        image: "./images/iMac Memoji4.svg",
        title: "Eagle Caterer Compani",
        desc: "Italian, American, 4 ++",
        rating: "4.7",
      },
      {
        image: "./images/iMac Memoji4.svg",
        title: "Eagle Caterer Compani",
        desc: "Italian, American, 4 ++",
        rating: "4.7",
      },
      {
        image: "./images/iMac Memoji4.svg",
        title: "Eagle Caterer Compani",
        desc: "Italian, American, 4 ++",
        rating: "4.7",
      },
  ];

  const slickArrowIconStyle = {
    fill: "#2b817b",
    background: "#f6f6f6",
    border: "1px solid #E1E1E6",
    borderRadius: "50%",
    // padding: "4px",
  };

  var settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    // nextArrow: <SampleNextArrow />,
    // prevArrow: <SamplePrevArrow />,
    // nextArrow: (
    //   <SlickArrow>
    //     <KeyboardArrowRightIcon name="arrow-next" size="10px" style={slickArrowIconStyle}  />
    //   </SlickArrow>
    // ),
    // prevArrow: (
    //   <SlickArrow>
    //     <KeyboardArrowLeftIcon name="arrow-prev" size="10px" style={slickArrowIconStyle}
    //     //  sx={{marginRight: "30px"}}
    //      />
    //   </SlickArrow>
    // ),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  // const settings = {
  //   dots: true,
  //   infinite: true,
  //   slidesToShow: 3,
  //   slidesToScroll: 1,
  //   autoplay: true,
  //   speed: 2000,
  //   autoplaySpeed: 2000,
  //   cssEase: "linear"
  // };

  return (
    <>
      <Box sx={{}}>
      <Box>
        <Typography
          sx={{ fontSize: {xl: "40px", lg: "40px", md: "40px", sm: "36px", xs: "30px"}, fontWeight: "600", pt: "60px", pb: "16px" }}
        >
          Available caterer near you ...
        </Typography>
      </Box>

        <Slider {...settings} className="slickSliderStyles">
          {caterers?.map((v, i) => {
            return (
              <>
                <Link to="/Meal_Plan" style={{textDecoration:'none',color:'black'}}>
                <Box
                  sx={{
                    // p: 2,
                    // margin: "auto",
                    // width: "416px",
                    width: "90%",
                    flexGrow: 1,
                    height: {xl: "140px", lg: "120px", md: "120px", sm: "120px", xs: "120px"},
                    // height: "auto",
                    border: "1px solid #F6F6F6",
                    display: "flex",
                    flexDirection: "row",
                    gap: "16px",
                    pt: "12px",
                    pl: {lg: "14px", md: "14px", sm: "14px", xs: "0px"},
                  }}
                >
                  <Box sx={{ width: {xl: "96px", lg: "96px", md: "96px", sm: "96px", xs: "96px"},
                  //  height: "96px"
                  height: "auto"
                    }}>
                                  <img src={"/images/iMac Memoji4.svg"} alt="" width="100%" />
                                </Box>

                                <Box>
                                  <Box>
                                    <Typography
                                      sx={{
                                        fontSize: {xl: "30px", lg: "24px", md: "24px", sm: "20px", xs: "18px"},
                                        fontWeight: "600",
                                      }}
                                    >
                                      {v.merchantName}
                                    </Typography>
                                  </Box>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      flexDirection: "row",
                                      alignItems:'center',
                                      fontSize: "14px",
                                      fontWeight: "500",
                                    }}
                                  >
                                    <Box color="#545359" >
                                      <LanguageIcon
                                      sx={{width: {xl: "20px", lg: "12px", md: "12px", sm: "12px", xs: "12px"},
                                      height: {xl: "50px", lg: "12.45px", md: "12.45px", sm: "12.45px", xs: "12.45px"}}}
                                      
                                      />
                                    </Box>
                                    <Typography color="#545359" sx={{fontSize: {xl: "16px", lg: "14px", md: "14px", sm: "10px", xs: "8px"}}}>
                                      {v.address}
                                    </Typography>
                                  </Box>

                                  <Box
                                    sx={{
                                      display: "flex",
                                      flexDirection: "row",
                                      alignItems:'center',
                                      color: "#FAA641",
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        // width: {xl: "30px", lg: "12px", md: "12px", sm: "12px", xs: "12px"},
                                        // height: {xl: "40px", lg: "12.45px", md: "12.45px", sm: "12.45px", xs: "12.45px"},
                                       
                                        pr: "10px",
                                      }}
                                    >
                                      <StarIcon  sx={{width: {xl: "14px", lg: "12px", md: "12px", sm: "12px", xs: "12px"},
                                    height: {xl: "50px", lg: "12.45px", md: "12.45px", sm: "12.45px", xs: "12.45px"}}} />
                                    </Box>
                                    <Box>
                                      <Typography
                                        sx={{
                                          fontSize: {xl: "14px", lg: "14px", md: "14px", sm: "14px", xs:"14px"},
                                          fontWeight: "600",
                                          pt: "2px",
                                          pl: "5px",
                                        }}
                                      >
                                        {v.rating}
                                      </Typography>
                                    </Box>
                                  </Box>
                                </Box>
                </Box>
                </Link>
                
              </>
            );
          })}
        </Slider>
      </Box>
    </>
  );
};
